import ru from 'vee-validate/dist/locale/ru';

export default Object.assign({}, ru, {
  custom: {
    email: {
      required: 'Пожалуйста, введите ваш адрес электронной почты',
    },

    name: {
      required: 'Пожалуйста, введите ваше имя',
    }, 

    phone: {
      required: 'Пожалуйста, введите номер вашего телефона',
    },

    gdpr_confirmed: {
      required: 'Пожалуйста, подтвердите, что вы ознакомились с пользовательским соглашением',
    },
  },
});
